module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-Regular.fa9b615a.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-Regular.woff2
// module id = 515
// module chunks = 0